import React, { useCallback } from 'react';
import { FavoriteIcon, FavoriteOutlineIcon, RawButton } from '@common-fe/common-fe';
import styled from 'styled-components';

interface Props {
  value: boolean;
  testId?: string;
  onChange: (value: boolean) => void;
}

const StyledButton = styled(RawButton)`
  height: 24px;
  cursor: pointer;
  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.iconAccent};
      stroke: ${({ theme }) => theme.colors.iconAccent};
    }
  }
`;

const ReportFavoriteButton: React.FC<Props> = ({ testId = 'report-favorite_button', value, onChange }) => {
  const handleToggleValue = useCallback(() => {
    onChange(!value);
  }, [onChange, value]);
  return (
    <StyledButton data-testid={testId} onClick={handleToggleValue}>
      {value ? <FavoriteIcon color="iconDisabled" /> : <FavoriteOutlineIcon color="iconDisabled" />}
    </StyledButton>
  );
};

export default ReportFavoriteButton;
